import {
  ISeparationGroupConfig,
  ISeparationGroupConfigRequest,
} from 'interfaces/ISeparationGroupService'

import { api as apiService, ApiService } from './api'

export type Days =
  | 'Sunday'
  | 'Monday'
  | 'Tuesday'
  | 'Wednesday'
  | 'Thursday'
  | 'Friday'
  | 'Saturday'

export interface ISettings {
  separations: number
  number_of_separators: number
  modified_by: number
  id: number
  created: Date
  goal_separate: number
  peak_days: Days[]
  token: string
  pallet_limit_weight: number
  pallet_limit_wholesale_box: number
  pending_order_blocks_loading: boolean
  stickers_by_box: number
}

export interface ISettingsRequest
  extends Omit<
    ISettings,
    | 'modified_by'
    | 'id'
    | 'created'
    | 'peak_days'
    | 'pallet_limit_weight'
    | 'pallet_limit_wholesale_box'
  > {
  numberOfSeparators: number
  goalSeparate: number
  peakDays: Days[]
  separationGroups: ISeparationGroupConfig[]
  palletLimitWeight: number
  palletLimitWholesaleBox: number
  PendingOrderBlocksLoading: boolean
  stickersByBox: number
}

export interface IToranjaConfig {
  markets_number_list: []
}

interface IToranjaConfigParams {
  marketNumbers: boolean
}

class SettingsService {
  constructor(private readonly api: ApiService) {}

  async getSettings(): Promise<ISettings> {
    return await this.api.get(`${carambolaUrl}/separation-settings/`)
  }

  async updateSettings(data: Partial<ISettingsRequest>): Promise<ISeparationGroupConfig> {
    return await this.api.post(`${carambolaUrl}/separation-settings/`, data)
  }

  async getSeparationGroup(): Promise<ISeparationGroupConfig[]> {
    return await this.api.get(`${carambolaUrl}/separation-settings/separation-group`)
  }

  async postSeparationGroup(data: ISeparationGroupConfigRequest): Promise<any> {
    return await this.api.post(`${carambolaUrl}/separation-settings/separation-group`, data)
  }

  async updateSeparationGroup(data: ISeparationGroupConfigRequest): Promise<any> {
    return await this.api.put(
      `${carambolaUrl}/separation-settings/separation-group/${data.separationGroup}`,
      data,
    )
  }

  async deleteSeparationGroup(separationGroup: Number): Promise<void> {
    return await this.api.delete(
      `${carambolaUrl}/separation-settings/separation-group/${separationGroup}`,
    )
  }

  async getToranjaConfig(params: IToranjaConfigParams): Promise<IToranjaConfig> {
    const { marketNumbers } = params
    return await this.api.get(
      `${carambolaUrl}/separation-settings/toranja-config?marketNumbers=${marketNumbers}`,
      {
        params,
      },
    )
  }

  public async getCurrent(): Promise<{ scheduled_date: string }> {
    return await this.api.get(`${carambolaUrl}/separation/current`)
  }
}

const carambolaUrl = process.env.REACT_APP_API_CARAMBOLA
export const settingsService = new SettingsService(apiService)
